import React from 'react';
import Link from 'react-router/lib/Link';
import './ServiceLayer.less';

function List({items}) {
  const renderItem = ({title, description, to}, index) => {
    return (
      <div key={index}>
        <h2>
          <img src='/imgs/home/service_symbol.png' alt='symbol' />
          <Link to={to}>{title}</Link>
        </h2>
        <div>{description}</div>
      </div>
    );
  };
  return (
    <div data-role='List'>
      {items.map(renderItem)}
    </div>
  );
}

function ServiceLayer({data: {img, title, items}, index}) {
  return (
    <div className='ServiceLayer' data-img={index % 2 ? 'right' : 'left'}>
      <div>
        <img src={img} alt='image' />
      </div>
      <div>
        <h2>{title}</h2>
        <List items={items}/>
      </div>
      <div>
        <img src={img} alt='image' />
      </div>
    </div>
  );
}

export default ServiceLayer;


// WEBPACK FOOTER //
// ./src/routes/Home/ServiceLayer.js